module.exports = __webpack_public_path__ + "static/Statistics-mp.92bd07ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Statistics-mp.jpg
// module id = 124
// module chunks = 133428282160390 225901961288281